import sidebar from './sidebar';

export default { sidebar };
